import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://ozpropertyservicesco.com.au";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "MovingCompany"],
  "name": "Oz Property Services Co.",
  "url": SITE_URL,
  "telephone": "1800 556 654",
  "email": "hello@ozpropertyservicesco.com.au",
  "areaServed": [
    { "@type": "City", "name": "Melbourne" },
    { "@type": "City", "name": "Broadmeadows" },
    { "@type": "City", "name": "Craigieburn" },
    { "@type": "City", "name": "Glenroy" },
    { "@type": "City", "name": "Fawkner" },
    { "@type": "City", "name": "Coburg" },
    { "@type": "City", "name": "Pascoe Vale" },
    { "@type": "City", "name": "Tullamarine" },
    { "@type": "City", "name": "Mickleham" },
    { "@type": "City", "name": "Epping" }
  ],
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "AU",
    "addressRegion": "VIC",
    "addressLocality": "Melbourne"
  },
  "makesOffer": [
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Interior Upgrades" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Outdoor Improvements" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Property Maintenance" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Security & Access" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Renovation Support" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Commercial Services" } }
  ],
  "sameAs": [
    "https://www.facebook.com/ozpropertyservicesco",
    "https://www.instagram.com/ozpropertyservicesco"
  ]
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Oz Property Services Co.",
  "url": SITE_URL
};

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <Helmet>
        <title>Page Not Found – Oz Property Services Co.</title>
        <meta
          name="description"
          content="The page you're looking for doesn't exist. Head back to Oz Property Services Co. for Melbourne property maintenance and upgrades."
        />
        <meta name="robots" content="noindex" />
        <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      </Helmet>
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold text-foreground">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
